import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'acabim-admin-onboarding-step-wrapper',
  templateUrl: './onboarding-step-wrapper.component.html',
  styleUrls: ['./onboarding-step-wrapper.component.scss']
})
export class OnboardingStepWrapperComponent implements OnInit {

  nextLabel = 'Next';
  finalStep = 8;
  skipFinancial = true;
  step = 1;
  @Output() submit = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {}

  onCancel(value: any): void {
    this.submit.emit('cancelled');
  }

  onDone(): void {
    this.submit.emit('completed');
  }

  onNext(nextStep: number): void {
    if (this.nextLabel === 'Complete') {
      this.step = 20;
    } else if (nextStep < (this.finalStep + 1)) {
      this.step = nextStep;
    }
    if (this.step === this.finalStep) {
      this.nextLabel = 'Complete';
    }
  }

  handleFinancial(value: string): void {
    if (value === 'disabled') {
      this.nextLabel = 'Complete';
      this.skipFinancial = true;
    } else {
      this.nextLabel = 'Next';
      this.skipFinancial = false;
    }
  }

}
